export interface SupportDataItem {
  tipType: string;
  tagCode: string;
}

export const supportData: Record<string, SupportDataItem> = {
  '/org-tree': { tipType: 'orgTree', tagCode: 'org_tree' },
};
